import { put, select, takeLatest } from "redux-saga/effects";
import { push } from "redux-first-history";

import { type RootState } from "@ds/store/bootstrap";

import { CONTENT_CAMPAIGNS_ROUTE, CONTENT_PLAYLISTS_ROUTE } from "@ds/constants/router";

import { contentActions } from "./slice";
import { ContentTableTypeEnum } from "../utils/model";

function* switchRoute({ payload }: ReturnType<typeof contentActions.switchView>) {
  let routeToSwitch = CONTENT_PLAYLISTS_ROUTE;
  switch (payload) {
    case ContentTableTypeEnum.Campaigns:
      routeToSwitch = CONTENT_CAMPAIGNS_ROUTE;
      break;
    case ContentTableTypeEnum.Playlists:
      routeToSwitch = CONTENT_PLAYLISTS_ROUTE;
      break;
  }

  const currentPathname: string = yield select((state: RootState) => state.router.location?.pathname ?? "");
  if (!currentPathname.startsWith(routeToSwitch)) {
    yield put(push(routeToSwitch));
  }
}

export function* watchCommon() {
  yield takeLatest(contentActions.switchView, switchRoute);
}
